import React from 'react';
import { GlobalOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import classNames from 'classnames';
import styles from './index.module.less';
import { useLocale } from '../../utils/i18n';

const Globe = (props) => {
  const [locale, setLocale] = useLocale();
  const { style, className } = props;
  const ref = React.useRef(null);
  const menu = (
    <Menu theme="dark">
      <Menu.Item key="zh-cn" onClick={() => setLocale('zh-cn')}>
        简体中文
      </Menu.Item>
      <Menu.Item key="en" onClick={() => setLocale('en')}>
        English
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} overlayClassName={styles.dropdown} getPopupContainer={() => ref.current}>
      <div className={classNames(styles.container, className)} style={style}>
        <span className={styles.languageName}>
          <GlobalOutlined className={styles.angleDown} />
          <span>{locale === 'zh-cn' ? '简体中文' : 'English'}</span>
        </span>
        <div ref={ref} />
      </div>
    </Dropdown>
  );
};

export default Globe;
